import React, { useState, useEffect } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Box,
  alpha,
  Divider,
  FormControl,
  InputLabel,
  Select,
  Stack,
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import PhoneIcon from "@mui/icons-material/Phone";
import WorkIcon from "@mui/icons-material/Work";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import InfoIcon from "@mui/icons-material/Info";
import TranslateIcon from "@mui/icons-material/Translate";
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import GTranslateIcon from "@mui/icons-material/GTranslate";
// import LanguageIcon from "@mui/icons-material/Language";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FacebookIcon from "@mui/icons-material/Facebook";
import MailOutlineIcon from "@mui/icons-material/MailOutline"; // Updated import
import WhatsAppIcon from "@mui/icons-material/WhatsApp"; // Updated WhatsAppIcon import
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import kurdish from "./Image/flag.png";
import english from "./Image/united-kingdom (2).png";
import i18n from "../../i18n";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
const DrawerComp = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorElServices, setAnchorElServices] = useState(null);
  const [language, setLanguage] = useState("");
  const { t } = useTranslation();

  const onChangeLang = (e) => {
    const selectedLang = e.target.value;
    setLanguage(selectedLang);
    i18n.changeLanguage(selectedLang);
    // Save to localStorage (i18next standard key)
    localStorage.setItem("i18nextLng", selectedLang);
    // Also save to cookies for backward compatibility
    Cookies.set("language", selectedLang);
  };

  useEffect(() => {
    // Try to get language from localStorage first (i18next standard key)
    const savedLang =
      localStorage.getItem("i18nextLng") || Cookies.get("language");
    if (savedLang) {
      setLanguage(savedLang);
      i18n.changeLanguage(savedLang);
      // Sync to localStorage if it was only in cookies
      if (!localStorage.getItem("i18nextLng") && savedLang) {
        localStorage.setItem("i18nextLng", savedLang);
      }
    }
  }, []);

  const handleMenuItemClick = () => {
    setOpenDrawer(false);
  };

  const handleServicesClick = (event) => {
    setAnchorElServices(event.currentTarget);
  };

  const handleServicesClose = () => {
    setAnchorElServices(null);
  };

  // const handleLanguageClick = (event) => {
  //   setAnchorElLanguage(event.currentTarget);
  // };

  // const handleLanguageClose = () => {
  //   setAnchorElLanguage(null);
  //   setOpenDrawer(false);
  // };

  const isServicesOpen = Boolean(anchorElServices);

  return (
    <React.Fragment>
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        PaperProps={{
          sx: {
            width: 300,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            boxShadow: "0 8px 32px rgba(102, 126, 234, 0.15)",
            borderLeft: `1px solid ${alpha("#667eea", 0.15)}`,
          },
        }}
        transitionDuration={300}
      >
        <List sx={{ pt: 2 }}>
          <ListItemButton
            component={Link}
            to="/"
            onClick={handleMenuItemClick}
            sx={{
              mx: 1.5,
              mb: 0.75,
              borderRadius: 2.5,
              py: 1.5,
              "&:hover": {
                background:
                  "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                color: "#667eea",
                transform: "translateX(6px)",
                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <HomeIcon sx={{ color: "#667eea", fontSize: 24 }} />
            </ListItemIcon>
            <ListItemText
              primary={t("Home")}
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: "1.05rem",
              }}
            />
          </ListItemButton>

          {/* Services option with dropdown menu */}
          <ListItemButton
            onClick={handleServicesClick}
            sx={{
              mx: 1.5,
              mb: 0.75,
              borderRadius: 2.5,
              py: 1.5,
              "&:hover": {
                background:
                  "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                color: "#667eea",
                transform: "translateX(6px)",
                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <WorkIcon sx={{ color: "#667eea", fontSize: 24 }} />
            </ListItemIcon>
            <ListItemText
              primary={t("Server")}
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: "1.05rem",
              }}
            />
            <ExpandMoreIcon sx={{ color: "#667eea" }} />
          </ListItemButton>
          <Menu
            anchorEl={anchorElServices}
            open={Boolean(anchorElServices)}
            onClose={handleServicesClose}
            PaperProps={{
              elevation: 0,
              sx: {
                mt: 1,
                ml: 1,
                borderRadius: 3,
                minWidth: 220,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                border: `1px solid ${alpha("#667eea", 0.2)}`,
                boxShadow: "0 8px 32px rgba(102, 126, 234, 0.15)",
                overflow: "hidden",
                "& .MuiMenuItem-root": {
                  px: 2.5,
                  py: 1.5,
                  borderRadius: 1.5,
                  mx: 1,
                  my: 0.5,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                    color: "#667eea",
                    transform: "translateX(4px)",
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            transitionDuration={300}
          >
            <MenuItem
              component={Link}
              to="/Translations"
              onClick={handleServicesClose}
            >
              <ListItemIcon>
                <TranslateIcon sx={{ color: "#667eea", fontSize: 22 }} />
              </ListItemIcon>
              <Box sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                {t("Translations")}
              </Box>
            </MenuItem>

            <MenuItem
              component={Link}
              to="/Transcriptions"
              onClick={handleServicesClose}
            >
              <ListItemIcon>
                <SubtitlesIcon sx={{ color: "#667eea", fontSize: 22 }} />
              </ListItemIcon>
              <Box sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                {t("Transcriptions")}
              </Box>
            </MenuItem>
            <MenuItem
              component={Link}
              to="/Interpreting"
              onClick={handleServicesClose}
            >
              <ListItemIcon>
                <GTranslateIcon sx={{ color: "#667eea", fontSize: 22 }} />
              </ListItemIcon>
              <Box sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                {t("Interpreting")}
              </Box>
            </MenuItem>
          </Menu>

          {!isServicesOpen && (
            <Box>
              <ListItemButton
                component={Link}
                to="/ContactUs"
                onClick={handleMenuItemClick}
                sx={{
                  mx: 1.5,
                  mb: 0.75,
                  borderRadius: 2.5,
                  py: 1.5,
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                    color: "#667eea",
                    transform: "translateX(6px)",
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <PhoneIcon sx={{ color: "#667eea", fontSize: 24 }} />
                </ListItemIcon>
                <ListItemText
                  primary={t("Contact")}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    fontSize: "1.05rem",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/Book_now"
                onClick={handleMenuItemClick}
                sx={{
                  mx: 1.5,
                  mb: 0.75,
                  borderRadius: 2.5,
                  py: 1.5,
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                    color: "#667eea",
                    transform: "translateX(6px)",
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <EventAvailableIcon sx={{ color: "#667eea", fontSize: 24 }} />
                </ListItemIcon>
                <ListItemText
                  primary={t("BookNow")}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    fontSize: "1.05rem",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/AboutUs"
                onClick={handleMenuItemClick}
                sx={{
                  mx: 1.5,
                  mb: 0.75,
                  borderRadius: 2.5,
                  py: 1.5,
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                    color: "#667eea",
                    transform: "translateX(6px)",
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <InfoIcon sx={{ color: "#667eea", fontSize: 24 }} />
                </ListItemIcon>
                <ListItemText
                  primary={t("About")}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    fontSize: "1.05rem",
                  }}
                />
              </ListItemButton>

              {/* Language option with dropdown menu */}
              {/* <ListItemButton onClick={handleLanguageClick}>
                <ListItemIcon>
                  <LanguageIcon />
                </ListItemIcon>
                <ListItemText>{t("Lang")}</ListItemText>
                <ExpandMoreIcon />
              </ListItemButton>
              <Menu
                value={language || ""}
                anchorEl={anchorElLanguage}
                open={Boolean(anchorElLanguage)}
                onClose={handleLanguageClose}
              >
                <MenuItem
                  onClick={() => {
                    onChangeLang("en");
                    handleLanguageClose();
                  }}
                >
                  <img src={UK} alt="Kurdistan Flag" height={25} width={25} />
                  {t("English")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    onChangeLang("ku");
                    handleLanguageClose();
                  }}
                >
                  <img
                    src={Kurdstan}
                    alt="Kurdistan Flag"
                    height={25}
                    width={25}
                  />
                  {t("Kurdish")}
                </MenuItem>
              </Menu> */}
              <Box
                sx={{
                  mx: 1.5,
                  mb: 0.75,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      backgroundColor: alpha("#ffffff", 0.9),
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: alpha("#ffffff", 1),
                        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                      },
                      "&.Mui-focused": {
                        backgroundColor: alpha("#ffffff", 1),
                        boxShadow: "0 4px 16px rgba(102, 126, 234, 0.2)",
                      },
                      "& fieldset": {
                        borderColor: alpha("#667eea", 0.3),
                        transition: "all 0.3s ease",
                      },
                      "&:hover fieldset": {
                        borderColor: alpha("#667eea", 0.5),
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#667eea",
                        borderWidth: 2,
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontWeight: 600,
                      color: "text.primary",
                      "&.Mui-focused": {
                        color: "#667eea",
                      },
                    },
                  }}
                >
                  <InputLabel id="language-select-label-drawer">
                    {t("Lang")}
                  </InputLabel>
                  <Select
                    labelId="language-select-label-drawer"
                    id="language-select-drawer"
                    value={language || ""}
                    onChange={onChangeLang}
                    label={t("Lang")}
                    MenuProps={{
                      disableScrollLock: true,
                      MenuListProps: {
                        disablePadding: true,
                      },
                      PaperProps: {
                        elevation: 8,
                        sx: {
                          mt: 1,
                          borderRadius: 2,
                          background:
                            "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%)",
                          backdropFilter: "blur(20px)",
                          WebkitBackdropFilter: "blur(20px)",
                          border: `1px solid ${alpha("#667eea", 0.2)}`,
                          boxShadow: "0 8px 32px rgba(102, 126, 234, 0.15)",
                          position: "fixed",
                          "& .MuiMenuItem-root": {
                            px: 2,
                            py: 1.5,
                            borderRadius: 1.5,
                            mx: 0.5,
                            my: 0.25,
                            transition: "all 0.3s ease",
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                              transform: "translateX(4px)",
                              boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                            },
                            "&.Mui-selected": {
                              background:
                                "linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)",
                              color: "#667eea",
                              fontWeight: 600,
                              "&:hover": {
                                background:
                                  "linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%)",
                              },
                            },
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="en">
                      <Stack
                        direction="row"
                        spacing={1.5}
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Box
                          component="img"
                          src={english}
                          alt="English Flag"
                          sx={{
                            width: 24,
                            height: 24,
                            objectFit: "cover",
                            borderRadius: "50%",
                            border: `2px solid ${alpha("#667eea", 0.2)}`,
                            transition: "all 0.3s ease",
                          }}
                        />
                        <Box
                          component="span"
                          sx={{
                            fontSize: "0.95rem",
                            fontWeight: 500,
                            color: "text.primary",
                          }}
                        >
                          {t("English")}
                        </Box>
                      </Stack>
                    </MenuItem>
                    <MenuItem value="ku">
                      <Stack
                        direction="row"
                        spacing={1.5}
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Box
                          component="img"
                          src={kurdish}
                          alt="Kurdish Flag"
                          sx={{
                            width: 24,
                            height: 24,
                            objectFit: "cover",
                            borderRadius: "50%",
                            border: `2px solid ${alpha("#667eea", 0.2)}`,
                            transition: "all 0.3s ease",
                          }}
                        />
                        <Box
                          component="span"
                          sx={{
                            fontSize: "0.95rem",
                            fontWeight: 500,
                            color: "text.primary",
                          }}
                        >
                          {t("Kurdish")}
                        </Box>
                      </Stack>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
          )}
        </List>

        {/* Social Media Icons at the Bottom */}
        <Box>
          <Divider sx={{ mx: 2, my: 2, borderColor: alpha("#667eea", 0.15) }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1.5,
              padding: 2.5,
            }}
          >
            <IconButton
              onClick={() =>
                window.open(
                  "https://www.facebook.com/profile.php?id=61554958468333&mibextid=2JQ9oc",
                  "_blank"
                )
              }
              sx={{
                color: "#3b5998",
                "&:hover": {
                  background: alpha("#3b5998", 0.1),
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
              }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              onClick={() =>
                window.open("mailto:contact@kts4u.co.uk", "_blank")
              }
              sx={{
                color: "#00acee",
                "&:hover": {
                  background: alpha("#00acee", 0.1),
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
              }}
            >
              <MailOutlineIcon />
            </IconButton>
            <IconButton
              onClick={() =>
                window.open(
                  "https://api.whatsapp.com/send?phone=447751655145&text=KTS4U",
                  "_blank"
                )
              }
              sx={{
                color: "#00712D",
                "&:hover": {
                  background: alpha("#00712D", 0.1),
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
              }}
            >
              <WhatsAppIcon />
            </IconButton>
            <IconButton
              onClick={() =>
                window.open(
                  "http://linkedin.com/in/kurdish-translation-services-4u-1282b12a9",
                  "_blank"
                )
              }
              sx={{
                color: "#0e76a8",
                "&:hover": {
                  background: alpha("#0e76a8", 0.1),
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
              }}
            >
              <LinkedInIcon />
            </IconButton>
          </Box>
        </Box>
      </Drawer>
      <IconButton
        sx={{
          color: "text.primary",
          marginLeft: "auto",
          fontWeight: "bold",
          borderRadius: 2,
          "&:hover": {
            background:
              "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
            color: "#667eea",
            transform: "scale(1.05)",
            boxShadow: "0 4px 12px rgba(102, 126, 234, 0.2)",
          },
          transition: "all 0.3s ease",
        }}
        onClick={() => setOpenDrawer(!openDrawer)}
      >
        <MenuIcon />
      </IconButton>
    </React.Fragment>
  );
};

export default DrawerComp;
